import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
const navLinks = [{
  name: 'Celebrate',
  href: '#celebrate'
}, {
  name: 'Honor',
  href: '#honor'
}, {
  name: 'Support',
  href: '#support'
}, {
  name: 'Event',
  href: '#event'
}, {
  name: 'Flyer',
  href: '#flyer'
}, {
  name: 'Partner',
  href: '#partner'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm border-b border-gray-100 transition-all duration-300 ease-out ${isScrolled ? 'shadow-sm' : ''}`} data-id="element-93">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <div className={`flex justify-between items-center transition-all duration-300 ease-out ${isScrolled ? 'h-16' : 'h-24'}`} data-id="element-95">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-96">
            <a href="#" className="flex items-center gap-3" data-id="element-97">
              <img src="https://cdn.magicpatterns.com/uploads/4tAPPhhSxFFzHh1MdQYkPw/Good_Father_Project.png" alt="Good Father Project Logo" className={`w-auto transition-all duration-300 ease-out ${isScrolled ? 'h-8' : 'h-12'}`} data-id="element-98" />
              <span className={`font-bold text-[#1a1a1a] hidden sm:block transition-all duration-300 ease-out ${isScrolled ? 'text-lg' : 'text-2xl'}`} data-id="element-99">
                Good Father Project
              </span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-100">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-gray-600 hover:text-[#4A6FA5] font-medium transition-all duration-300 ${isScrolled ? 'text-sm' : 'text-base'}`} data-id="element-101">
                {link.name}
              </a>)}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-102">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-[#1a1a1a] p-2" aria-label="Toggle menu" data-id="element-103">
              {isOpen ? <X size={24} data-id="element-104" /> : <Menu size={24} data-id="element-105" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && <div className="md:hidden bg-white border-b border-gray-100 shadow-lg absolute w-full" data-id="element-106">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-107">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-gray-600 hover:text-[#4A6FA5] hover:bg-gray-50 rounded-md" onClick={() => setIsOpen(false)} data-id="element-108">
                {link.name}
              </a>)}
          </div>
        </div>}
    </nav>;
}